import React from 'react';
import { cn } from '../../lib/utils';

const Select = React.forwardRef(
  ({ className, value, onChange, placeholder, children, ...props }, ref) => {
    return (
      <select
        ref={ref}
        value={value}
        onChange={onChange}
        className={cn(
          'flex h-10 w-full items-center justify-between rounded-md border border-zinc-200 bg-white px-3 py-2 text-sm ring-offset-white placeholder:text-zinc-500 focus:outline-none focus:ring-2 focus:ring-zinc-400 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
          className
        )}
        {...props}
      >
        {placeholder && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {children}
      </select>
    );
  }
);

Select.displayName = 'Select';

function SelectOption({ className, ...props }) {
  return <option className={cn(className)} {...props} />;
}

export { Select, SelectOption };
